import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { CSVLink } from 'react-csv';
import { useUser } from '../context/UserContext';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';

const UserFeedback = () => {
  const { selectedCenter } = useUser();
  const [academy, setAcademy] = useState(selectedCenter);
  const [coachName, setCoachName] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [coaches, setCoaches] = useState([]);
  const [academyOptions, setAcademyOptions] = useState([]);
  const [feebackData, setfeebackData] = useState([]);
  const [dateRange, setDateRange] = useState({
    start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0],
    end: new Date().toISOString().split('T')[0]
  });


  const fetchAcademyAndFeedback = async () => {
    setLoading(true);
    setError(null);

    try {
      const academyCoachResponse = await fetch(process.env.REACT_APP_API_COACH_LIST, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'x-authorization': process.env.REACT_APP_AUTH_TOKEN,
        },
      });

      const academyCoachData = await academyCoachResponse.json();

      if (!academyCoachData.success || !academyCoachData.data?.data?.length) {
        setError("Received invalid or empty data from the API.");
        return;
      }

      const academies = academyCoachData.data.data.map((academy) => ({
        value: academy.academyId.toString(),
        label: academy.academyName,
      }));

      const coachesList = academyCoachData.data.data.flatMap((academy) =>
        academy.coach.map((coach) => ({
          value: coach.coachUserId,
          label: coach.coachName.trim(),
          academy: academy.academyId.toString(),
          contact: coach.contactNo,
          coachType: coach.coachType,
        }))
      );

      setAcademyOptions(academies);
      setCoaches(coachesList);

      const uniqueCoachIds = Array.from(new Set(coachesList.map(coach => coach.value)));
      const coachIds = uniqueCoachIds.join(",");

      if (!coachIds) return;

      const feedbackResponse = await fetch(`${process.env.REACT_APP_API_USER_FEEDBACK}?source_user_ids=${coachIds}` +
        `&academy_id=${academy}` +
        `&start_date=${dateRange.start}` +
        `&end_date=${dateRange.end}`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'x-authorization': process.env.REACT_APP_AUTH_TOKEN,
        },
      });

      const feedbackData = await feedbackResponse.json();

      if (!feedbackData.success) {
        return;
      }

      const updatedData = feedbackData.data.feedbacks.map((feedback) => {
        const coachInfo = coachesList.find(c => c.value === feedback.source?.id);
        return {
          id: feedback.id || null,
          academyId: feedback.academyId || "Unknown Academy",
          academy: feedback.academyName || "Unknown Academy",
          name: feedback.source?.name || "Unknown Coach",
          coachContact: coachInfo?.contact?.replace(/^\+91/, "") || "N/A",
          coachType: coachInfo?.coachType || "N/A",
          feedbackTime: new Date(feedback.feedbackDate).toLocaleString('default', { month: 'long', year: 'numeric' }),
          player: feedback.target?.name || "Unknown Player",
          playerContact: feedback.target?.mobile_number?.replace(/^\+91/, "") || "N/A",
          feedbackMonth: new Date(feedback.feedbackDate).toLocaleString('default', { month: 'long', year: 'numeric' }),
          feedback: feedback.review || "No feedback available",
          feedbackDate: feedback.feedbackDate?.split("T")[0] || "N/A",
          parentContact: feedback.targetParentMobile?.replace(/^\+91/, "") || "N/A",
        };
      });

      setfeebackData(updatedData);
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAcademyAndFeedback();
  }, [selectedCenter, academy, dateRange]);



  const getAcademyName = (academyId) => {
    const academy = academyOptions.find((a) => String(a.value) === String(academyId));
    return academy ? academy.label : "Unknown Academy";
  };

  const headers = [
    { label: "Academy Name", key: "academy" },
    { label: "Player Name", key: "player" },
    { label: "Player Contact", key: "playerContact" },
    { label: "Parent Contact", key: "parentContact" },
    { label: "Coach Name", key: "name" },
    { label: "Coach Contact", key: "coachContact" },
    { label: "Coach Type", key: "coachType" },
    { label: "Feedback Month Year", key: "feedbackTime" },
    { label: "Feedback", key: "feedback" },
    { label: "Given on", key: "feedbackDate" },
  ];

  const filteredData = feebackData.filter((enrollment) => {

    const isAcademyMatch = academy
      ? String(enrollment.academyId) === String(academy)
      : true;

    const isCoachMatch = coachName ? enrollment.name === coachName : true;
    const isDateMatch = enrollment.feedbackDate >= dateRange.start && enrollment.feedbackDate <= dateRange.end;
    const isSearchMatch = searchTerm ? enrollment.player.toLowerCase().includes(searchTerm.toLowerCase()) : true;
    return isAcademyMatch && isCoachMatch && isDateMatch && isSearchMatch;
  });


  useEffect(() => {
    const uniqueCoachNames = Array.from(
      new Set(feebackData.map((f) => f.name).filter(Boolean))
    );
    const coachOptions = uniqueCoachNames.map((c) => ({
      value: c,
      label: c,
    }));
    setCoaches(coachOptions);

    if (coachName && !uniqueCoachNames.includes(coachName)) {
      setCoachName('');
    }
  }, [feebackData]);


  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };
  const handleSort = (columnKey) => {
    let direction = "ascending";
    if (sortConfig.key === columnKey && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key: columnKey, direction });
  };
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const sortData = (data) => {
    const { key, direction } = sortConfig;
    return [...data].sort((a, b) => {
      if (a[key] < b[key]) return direction === "ascending" ? -1 : 1;
      if (a[key] > b[key]) return direction === "ascending" ? 1 : -1;
      return 0;
    });
  };
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortData(filteredData).slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };
  const totalEntries = filteredData.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  useEffect(() => {
    const uniqueAcademies = Array.from(new Set(feebackData.map((item) => item.academy)))
      .map((academy) => ({ value: academy, label: academy }));
    setAcademyOptions(uniqueAcademies);
  }, []);

  useEffect(() => {
    const filteredCoaches = academy
      ? feebackData
        .filter((item) => item.academy === academy)
        .map((item) => ({ value: item.name, label: item.name }))
      : feebackData.map((item) => ({ value: item.name, label: item.name }));

    setCoaches(filteredCoaches);
  }, [academy]);




  return (
    <div className="enrollment-container">

      <div className="sales-filters-login">
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${academy ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={academyOptions}
            value={academyOptions.find(option => option.value === academy)}
            onChange={(selectedOption) => setAcademy(selectedOption?.value || '')}
            placeholder="Select Academy"
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {academy && <label htmlFor="academy">Academy</label>}
        </div>
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${coachName ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={coaches}
            value={coaches.find(option => option.value === coachName)}
            onChange={(selectedOption) => setCoachName(selectedOption?.value || '')}
            placeholder="Select Coach"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />

          {coachName && <label htmlFor="coachName">Coach</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${dateRange.start ? "has-value" : ""}`}
            value={dateRange.start}
            onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          {dateRange.start && <label htmlFor="startDate">Start Date</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${dateRange.end ? "has-value" : ""}`}
            value={dateRange.end}
            onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          {dateRange.end && <label htmlFor="endDate">End Date</label>}
        </div>

      </div>
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>

        <CSVLink
          data={filteredData}
          headers={headers}
          filename="UserFeedback.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>
      </div>
      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
          <option value={100}>100 items per page</option>
        </select>
        <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchAcademyAndFeedback}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>

      </div>
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredData.length === 0 && (
        <div className="error-message">No data available</div>
      )}

      <div className="tt-table-container">
        <table className="tt-table">

          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th
                  key={key}
                  className="challenges-column"
                  onClick={() => handleSort(key)}
                >
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.key === key && sortConfig.direction === 'descending'
                          ? 'desc'
                          : ''
                        }`}
                    />
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {filteredData.length > 0 ? (
              currentRows.map((enrollment) => (
                <tr key={enrollment.id} className="border">
                  <td>{enrollment.academy}</td>
                  <td>{enrollment.player}</td>
                  <td>{enrollment.playerContact}</td>
                  <td>{enrollment.parentContact}</td>
                  <td>{enrollment.name}</td>
                  <td>{enrollment.coachContact}</td>
                  <td>{enrollment.coachType}</td>
                  <td>{enrollment.feedbackTime}</td>
                  <td>{enrollment.feedback}</td>
                  <td>{enrollment.feedbackDate}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center p-4">No enrollments found</td>
              </tr>
            )}
          </tbody>

        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default UserFeedback;
